/**
 * As abas do portfólio, lidas do servidor.
 *
 * ## O que mudou em 25/10, e por quê
 *
 * Isto era uma lista de doze nomes escrita à mão. Acrescentar a aba de um setor
 * novo exigia mexer no código e subir uma versão — para um dado que é de
 * administração, não de engenharia.
 *
 * Agora as abas são cadastro (`catalog_area`), e este arquivo só as busca e as
 * guarda em memória enquanto a aba do navegador estiver aberta.
 *
 * ## Por que há um valor de partida
 *
 * Entre abrir a tela e a resposta chegar existe um instante. Sem nada, a barra
 * de abas nasceria vazia e pularia quando a lista chegasse. A lista de partida
 * é a que existia até 25/10 — não é a verdade, é um primeiro quadro plausível,
 * substituído assim que o servidor responde.
 *
 * Ela **não** é o que o catálogo filtra: isso sai sempre do que o servidor
 * mandou. Serve só para a barra não piscar.
 */
import { apiFetch } from './api.js';

/** O curinga. Não é uma área — faz o item aparecer em todas as abas. */
export const TODAS = 'Todos';

/** O primeiro quadro, enquanto a resposta não chega. Ver o cabeçalho. */
export const AREAS_INICIAIS = Object.freeze([
  'Comercial',
  'CSC',
  'DGI',
  'Engenharia',
  'Financeiro',
  'Iretail',
  'Jurídico',
  'Marketing',
  'Mix',
  'Operações',
  'RH',
  'TI',
]);

/**
 * Guardado por aba do navegador.
 *
 * As abas mudam quando alguém as edita no painel, o que é raro, e quem editou
 * vê a lista nova na própria resposta da edição. Buscar de novo a cada tela
 * seria uma requisição por navegação para um dado que quase nunca muda.
 */
let cache = null;
let buscando = null;

/**
 * As abas ativas, do servidor.
 *
 * Falhar devolve a lista de partida em vez de estourar: a barra de abas é
 * navegação, e uma falha de rede nela não deveria apagar o portfólio da tela.
 */
export async function carregarAreas() {
  if (cache) return cache;
  if (buscando) return buscando;

  buscando = apiFetch('/api/areas')
    .then((r) => {
      cache = Array.isArray(r?.areas) && r.areas.length ? r.areas : [...AREAS_INICIAIS];
      return cache;
    })
    .catch(() => [...AREAS_INICIAIS])
    .finally(() => {
      buscando = null;
    });

  return buscando;
}

/** Joga fora o guardado. Chamado pelo painel depois de editar as abas. */
export function esquecerAreas() {
  cache = null;
}

export default { TODAS, AREAS_INICIAIS, carregarAreas, esquecerAreas };
